module.exports = __webpack_public_path__ + "static/googlecloud-d9d7c382b5a571849a51fbeefabf38e7.svg";